module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    staticClass: "content-wrapper"
  }, [(_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.events != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются данные по событиям\n")]) : _c('div', {
    staticStyle: {
      "width": "100vw",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "datalist"
  }, [_c('div', {
    staticClass: "datalist-scroll",
    attrs: {
      "id": "scrollingdiv"
    }
  }, [_c('div', {
    staticClass: "events-buttons"
  }, [_c('div', {
    staticClass: "events-button events-button1",
    class: _vm.viewMode == 1 ? 'events-button-active' : '',
    on: {
      "click": function($event) {
        _vm.viewMode = 1
      }
    }
  }, [_vm._v("НОВОЕ")]), _vm._v(" "), _c('div', {
    staticClass: "events-button events-button2",
    class: _vm.viewMode == 3 ? 'events-button-active' : '',
    on: {
      "click": function($event) {
        _vm.viewMode = 3
      }
    }
  }, [_vm._v("МОИ СОБЫТИЯ")]), _vm._v(" "), _c('div', {
    staticClass: "events-button events-button3",
    class: _vm.viewMode == 2 ? 'events-button-active' : '',
    on: {
      "click": function($event) {
        _vm.viewMode = 2
      }
    }
  }, [_vm._v("ПРОШЛОЕ")])]), _vm._v(" "), _c('div', {
    staticClass: "events-buttons-tags"
  }, [_c('div', {
    staticClass: "events-button events-button-tag",
    class: _vm.filterTag == '' ? 'events-button-active' : '',
    on: {
      "click": function($event) {
        _vm.filterTag = ''
      }
    }
  }, [_vm._v("все")]), _vm._v(" "), _vm._l((_vm.serverData.appSettings.events.tags), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "events-button events-button-tag",
      class: _vm.filterTag == tag ? 'events-button-active' : '',
      on: {
        "click": function($event) {
          _vm.filterTag = tag
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag) + "\n    ")])
  })], 2), _vm._v(" "), (_vm.filteredData.length == 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "20px 20px 0 20px",
      "font-size": "17px",
      "float": "left"
    }
  }, [_vm._v("Нет событий")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredData), function(event, key) {
    return _c('div', {
      key: event.val.id
    }, [(event.type == 2) ? _c('DIV', {
      staticClass: "date-title"
    }, [_vm._v("\n      " + _vm._s(event.text) + "\n    ")]) : _c('DIV', {
      staticClass: "event",
      on: {
        "click": function($event) {
          if (_vm.preventToGoToEvent == false) { _vm.dataRowOnSelect(event); }
          _vm.preventToGoToEvent = false
        }
      }
    }, [_c('div', {
      staticClass: "event-image",
      style: ({
        'background-image': 'url(' + _vm.serverData.imagesGetURL(event.val.body.images[0]) + ')'
      })
    }, [(event.val.status != 1) ? _c('div', {
      staticClass: "event-status",
      style: ({
        'background': _vm.getEventStatusBackground(event)
      })
    }, [_vm._v("\n        " + _vm._s(_vm.getEventStatusText(event))), _c('br'), _vm._v("по причине: " + _vm._s(event.val.body.cancelReason) + "\n      ")]) : _vm._e(), _vm._v("\n       \n    ")]), _vm._v(" "), _c('DIV', {
      staticClass: "event-info"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "0",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "event-name"
    }, [_vm._v(_vm._s(event.val.name))])]), _vm._v(" "), _c('div', {
      staticClass: "event-prop",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "link event-user-avatar",
      style: ({
        'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.serverData.usersMap[event.val.createdBy].body.avatar) + ')'
      }),
      on: {
        "click": function($event) {
          _vm.preventToGoToEvent = true;
          _vm.goToUserCard(event.val.createdBy)
        }
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "link",
      staticStyle: {
        "padding-top": "4px",
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.preventToGoToEvent = true;
          _vm.goToUserCard(event.val.createdBy)
        }
      }
    }, [_vm._v(_vm._s(_vm.serverData.usersMap[event.val.createdBy].name))])]), _vm._v(" "), _c('div', {
      staticClass: "event-prop",
      staticStyle: {
        "padding-top": "5px"
      }
    }, [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          _vm.preventToGoToEvent = true;
          _vm.goToPlaceCard(event.val.place)
        }
      }
    }, [_vm._v(_vm._s(_vm.serverData.placesMap[event.val.place].val.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "50%",
        "padding": "10px 0 0 0",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "event-prop-left",
      staticStyle: {
        "padding-top": "0px"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(event.val.dateStart, 'date + weekday + reservedWords')))]), _vm._v(" "), _c('div', {
      staticClass: "event-prop-left",
      staticStyle: {
        "padding-top": "0px"
      }
    }, [_vm._v("\n        " + _vm._s(event.val.timeStart) + " - " + _vm._s(event.val.timeEnd) + "\n      ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "50%",
        "padding": "10px 0px 0px 0",
        "float": "left"
      }
    }, [((event.membering.members.length > 0) || (event.membering.possible.length > 0)) ? _c('div', {
      staticClass: "event-prop-right text-align-right",
      staticStyle: {
        "padding-top": "0px"
      }
    }, [_vm._v("Участники: " + _vm._s(event.membering.members.length))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "event-prop-right text-align-right",
      staticStyle: {
        "padding-top": "0px"
      }
    }, [_vm._v(" "), (event.membering.possible.length > 0) ? _c('span', [_vm._v("Возможно: " + _vm._s(event.membering.possible.length))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "event-prop",
      staticStyle: {
        "padding-top": "7px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(event.val.price != 0 ? 'Стоимость: ' + event.val.price + ' р' : ' '))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "0px 0px 20px 0",
        "float": "left"
      }
    }, [_vm._v(" ")])])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-space"
  }, [_vm._v(" ")])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09d02702","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events.vue
// module id = 351
// module chunks = 0